import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import ModalPopup from '../common/ModalPopup'
import SuperFeedFilter from './Filter'
import ListView from './ListView'
import GridView from './GridView'
// import { getBrands, getExtensionUsersCount } from '../../store/entities/customers'
import { loadSuperFeedEvents, resetSuperFeedEventsTotal, setCurrentPage, setCurrentView } from '../../store/entities/superFeedEvents'
// import { isGlobalView } from '../../utilities/config'
import './SuperFeed.scss'
// import IncidentCharts from '../incidentCharts'
import { getStatusClass } from '../../utilities/statusCSSClass'
import { withRouter } from 'react-router-dom';
import Pagination from '../common/paginator/pagination';
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';


class SuperFeed extends Component {
  state = {
    // viewType: 'list',
    showPopup : false,
    customerId: this.props.selectedCustomer ? this.props.selectedCustomer.id : null,
    filterBy: {
      "rrURLYN": "N",
      "incldFP": "N",
      "dtTS": "last30d"
    },
    sortBy: [],
    isFirstLoad: true,
    params: {},
  }

  componentDidMount() {
    if(this.state.isFirstLoad && this.props.events.length === 0) {
      this.setState({ isFirstLoad: false });
      this.props.loadSFEvents(this.props.pageNo, this.props.pageSize, this.state.customerId, this.state.filterBy, this.state.sortBy, this.props.params);
    } else {

    }
  }

  componentDidUpdate(prevProps) {
 }
  
  handleDetails = (record) => {
    this.props.history.push(`/super-feed/${record.eventId}`);
  }

  handleViewSelect = (viewType) => {
    // this.setState({ viewType: viewType })
    this.props.setCurrentView(viewType);
  }

  handleStatsChart = () => {
    this.props.history.push(`/super-feed/stats`);
  }

  handleFilterChange = (filterBy, advanceFilters, arrSortCriteria, pageNo = 1) => {
    this.props.resetSuperFeedEventsTotal();
    this.props.setCurrentPage(pageNo, -1);
    let strSortBy = arrSortCriteria.map(criteria => `${criteria.fieldName}|${criteria.order}`);
    let advanceFilter = advanceFilters.reduce((acc, filter) => {
      if(filter.value && filter.value.length > 0) {
        acc[filter.fieldName] = filter.value;
      }
      return acc;
    }, {});
    let objNewFilters = { ...filterBy, ...advanceFilter };
    this.setState({ filterBy: objNewFilters, advanceFilters: advanceFilters, sortBy: strSortBy});
    this.props.loadSFEvents(this.props.pageNo, this.props.pageSize, this.state.customerId, objNewFilters, strSortBy, this.state.params);
  }


  getPrevPageData = (pageNo, pageSize) => {
    this.props.setCurrentPage(pageNo, this.props.maxPageNo);
 }

  getNextPageData = (pageNo, pageSize) => {
    // this.setState({ pageNo });
    let { events, isLastPage } = this.props;
    if(!isLastPage && (pageNo > this.props.maxPageNo)) {
      this.props.setCurrentPage(pageNo, pageNo);
      this.props.loadSFEvents(pageNo, pageSize, this.state.customerId, this.state.filterBy, this.props.sortBy, this.props.params);
    } else {
      this.props.setCurrentPage(pageNo, this.props.maxPageNo);
    }
 }

  getCustomerName = (customerId) => {
      const customer = this.props.customers.find(c => c.id === customerId);
      return customer ? customer.displayName : 'NA';
  }

  render() {
    const viewType = this.props.viewType ? this.props.viewType : this.props.defaultView;
    // console.log("SuperFeed render - viewType", viewType);
    const { pageSize, pageNo, maxPageNo, events } = this.props
    const viewTypeComponentMap = {
          'grid': GridView,
          'list': ListView
        }
    const ViewComponent = viewTypeComponentMap[viewType] || ListView
    let filterState = "";
    try {
      filterState = JSON.stringify(this.state.filterBy) + JSON.stringify(this.state.sortBy);
    } catch (e) {
      console.error("Error occurred while processing filter and sort state:", e);
    }
    // Calculate the starting and ending index for the current page
    const startIdx = (pageNo - 1) * pageSize;
    const endIdx = startIdx + pageSize;
    // Create a new array with the current page records (do not mutate original array)
    let currentPageRecords = Array.isArray(events) && events.length > 0
      ? events.slice(startIdx, endIdx)
      : [];
    let onLastPage = this.props.isLastPage && (pageNo >= maxPageNo);
    return (
      <>
          <div>
            <SuperFeedFilter
              viewType={viewType}
              urlId={this.props.match.params.id}
              onViewSelect={this.handleViewSelect}
              onFilterChange={this.handleFilterChange}
            />
          </div>
          {this.props.loading || this.props.events.length === 0 ?
            <LoaderWrapper
              loading={this.props.loading} data={this.props.events ? this.props.events : []}
              styles={{ minHeight: '500px', padding: '30px' }} placeholderText={"No Threats Detected"}
            />
            :
          <>
          <div>
            <ViewComponent
              pageNo={this.props.pageNo}
              events={currentPageRecords}
              pageSize={this.props.pageSize}
              totalSize={this.props.totalSize}
              isLastPage={onLastPage}
              sortBy={this.props.sortBy}
              filterBy={this.state.filterBy}
              onDetails={this.handleDetails} 
              getStatusClass={getStatusClass}
              getCustomerName={this.getCustomerName}
              />
          </div>
          <div>
            <Pagination resetOnChange={filterState} initialPageNo={this.props.pageNo} isLastPage={this.props.isLastPage && pageNo >= maxPageNo} pageSize={this.props.pageSize} getPrevPageData={this.getPrevPageData} getNextPageData={this.getNextPageData} loaderFlag={this.props.loading != undefined ? this.props.loading : false} />
          </div>
        </>}
          {this.props.superFeedStatus ? <ModalPopup statusCode={this.props.superFeedStatus} msg={this.props.superFeedUserMsg} /> : null}

      </>
    )
  }
}


const mapStateToProps = (state) => ({
  // filters: state.entities.superFeedEvents.events.list,
  viewType: state.entities.superFeedEvents.superFeedView.currentView,
  defaultView: state.entities.superFeedEvents.superFeedView.default,
  viewList: state.entities.superFeedEvents.superFeedView.list,
  events: state.entities.superFeedEvents.list,
  isLastPage: state.entities.superFeedEvents.isLastPage,
  loading: state.entities.superFeedEvents.loading,
  pageNo: state.entities.superFeedEvents.pageNo,
  maxPageNo: state.entities.superFeedEvents.maxPageNo,
  pageSize: state.entities.superFeedEvents.pageSize,
  totalSize: state.entities.superFeedEvents.totalSize,
  sortBy: state.entities.superFeedEvents.sortBy,
  // filterBy: state.entities.superFeedEvents.filterBy,
  params: state.entities.superFeedEvents.params,
  selectedCustomer: state.entities.customers.selected,
  customers: state.entities.customers.list,
  // eventStatusCode: state.entities.events.statusCode,
  eventUserMsg: state.entities.events.userMsg,
  superFeedStatus: state.entities.superFeedEvents.statusCode,
  superFeedUserMsg: state.entities.superFeedEvents.userMsg

})

const mapDispatchToProps = (dispatch) => ({
  loadSFEvents: (pageNo, pageSize, customerId, filterBy, sortBy, params) => dispatch(loadSuperFeedEvents(pageNo, pageSize, customerId, filterBy, sortBy, params)),
  resetSuperFeedEventsTotal: () => dispatch(resetSuperFeedEventsTotal()),
  setCurrentPage: (pageNo, maxPageNo) => dispatch(setCurrentPage(pageNo, maxPageNo)),
  setCurrentView: (viewType) => dispatch(setCurrentView(viewType))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuperFeed))
